import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  IconButton,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import { ChangeHistory as TriangleUp } from "@material-ui/icons";
import useStyles from "./styles";
import DecoratedBox from "../DecoratedBox";

export default function NumericDataBlock({
  title,
  highlight,
  caption,
  icon,
  action,
  size,
  growthDirection,
  isLoading,
}) {
  const {
    bold,
    titleTypography,
    highlightTypography,
    captionTypography,
    iconButton,
    spinnerContainer,
    spinner,
  } = useStyles({ size, growthDirection });
  return (
    <DecoratedBox item xs={12} container direction="column">
      <Grid item xs={12} container>
        <Grid item xs={icon ? 11 : 12}>
          <Typography variant="h6" className={titleTypography} noWrap>
            {title}
          </Typography>
        </Grid>
        {icon && (
          <Grid item xs={1} container justify="flex-end">
            <IconButton onClick={action} className={iconButton}>
              {icon}
            </IconButton>
          </Grid>
        )}
      </Grid>
      {!isLoading ? (
        <>
          {highlight !== undefined && (
            <Grid item xs={12}>
              <Typography
                variant="h4"
                className={`${bold} ${highlightTypography}`}
                noWrap
              >
                {highlight}
              </Typography>
            </Grid>
          )}
          {caption !== undefined && (
            <Grid item xs={12} container alignItems="center">
              <Typography variant="h6" className={captionTypography} noWrap>
                {caption} {growthDirection && <TriangleUp />}
              </Typography>
            </Grid>
          )}
        </>
      ) : (
        <Grid
          className={spinnerContainer}
          item
          container
          xs={12}
          justify="center"
          alignItems="center"
        >
          <CircularProgress className={spinner} />
        </Grid>
      )}
    </DecoratedBox>
  );
}

NumericDataBlock.defaultProps = {
  title: undefined,
  highlight: undefined,
  caption: undefined,
  icon: undefined,
  action: () => {},
  size: 16,
  growthDirection: undefined,
  isLoading: false,
};

NumericDataBlock.propTypes = {
  title: PropTypes.string,
  highlight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  caption: PropTypes.string,
  icon: PropTypes.node,
  action: () => {},
  size: PropTypes.number,
  growthDirection: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isLoading: PropTypes.bool,
};
